import Template from "backbone/projects/templates/clip_pub_format_result.js.hamlc"

export default class ClipPublicationView extends Backbone.View
  initialize: ->
    that = @
    @$el.select2(
      placeholder: "Start typing to find the client or publication."
      ajax:
        url: "/clip_publications/autocomplete.json"
        delay: 200
        dataType: "json"
        data: (params) ->
          term: params.term
          page: params.page
        processResults: that._formatForSelect
      templateSelection: (result) ->
        that._clipPubFormatResult(result)
      templateResult: (result) ->
        that._clipPubFormatResult(result)
      escapeMarkup: (markup) ->
        return markup
    )

  _clipPubFormatResult: (clipPub) ->
    if clipPub.id != ""
      Template(favicon_url: clipPub.favicon_url, name: clipPub.name, domain: clipPub.domain)
    else
      clipPub.text

  _formatForSelect: (results, page) ->
    data = []
    for result in results
      result.text = result.name
      data.push(result)
      more = (page * 10) < data[0].total
    results: data, more: more



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/clip_publication_view.js.coffee